import getLabels from './labels';

/**
 * Global @var labels used to translate the application.
 */
export const currentLanguage = jQuery('body').data('lang-slug');
export const labels = getLabels();
export const currency = '€';
export const tax = 1.21;

/**
 * Data about API.
 */
export const apiInfo = {
    networkId: 'WONDERGROUP',
    garageId: 'GB12567',
    liveGarageId: 'GB30283',
    garageName: 'WONDERGROUP Test Garage',
    language: 'be',
};

/**
 * All data related to user selections through the application.
 */

export let QT = {
    issue: '',
    vehicleType: 'vin',
    wpServiceId: 0,
    apiServiceId: 0,
    serviceName: '',
    marqueId: 0,
    marqueName: 0,
    modelId: 0,
    modelName: 0,
    versionId: 0,
    versionName: '',
    vehicleId: 0,
    vehicleVin: '',
    serviceQuote: 0,
    dropOffHours: '',
    dropOffDay: '',
    dropOffYear: '',
    dropOffRawDate: '',
    dropOffRawHours: '',
    firstname: '',
    lastname: '',
    phone: '',
    email: '',
    description: '',
    weeksInFuture: 0,
    otherService: 0,
    particularServiceSelected: false,
};

/**
 * Global @var stepHistory used to control state of the application.
 */

export let history = ['start']
if (jQuery('#appointment-tool').length > 0) {
    history = ['garage-locator'];
}

/**
 * Tracking variables
 */
export let analytics = analyticstracker();
